import { Link } from "react-router-dom";
import { Container, Box, Typography, Card, CardContent, Button, Grid } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import HomeIcon from "@mui/icons-material/Home";
import SearchIcon from "@mui/icons-material/Search";
import SportsCricketIcon from "@mui/icons-material/SportsCricket";

export default function NotFound() {
  return (
    <SoftBox
      minHeight="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      bgColor="grey-100"
      px={2}
    >
      <Container maxWidth="md">
        <Card elevation={3}>
          <CardContent sx={{ p: 4, textAlign: "center" }}>
            <Box mb={3}>
              <Typography variant="h1" component="h1" sx={{ fontSize: { xs: '4rem', md: '6rem' }, fontWeight: 'bold', color: 'primary.main' }}>
                404
              </Typography>
            </Box>
            
            <SoftTypography variant="h4" color="dark" fontWeight="bold" mb={2}>
              Page Not Found
            </SoftTypography>
            
            <SoftTypography variant="body1" color="text" mb={4}>
              Oops! The page you're looking for doesn't exist or has been moved. 
              Don't worry, we've got you covered. Here are some helpful links to get you back on track:
            </SoftTypography>

            <Grid container spacing={2} justifyContent="center" mb={4}>
              <Grid item xs={12} sm={6} md={4}>
                <SoftButton
                  component={Link}
                  to="/"
                  variant="contained"
                  color="primary"
                  fullWidth
                  startIcon={<HomeIcon />}
                  sx={{ py: 1.5 }}
                >
                  Home Page
                </SoftButton>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <SoftButton
                  component={Link}
                  to="/groups"
                  variant="contained"
                  color="primary"
                  fullWidth
                  startIcon={<SportsCricketIcon />}
                  sx={{ py: 1.5 }}
                >
                  My Groups
                </SoftButton>
              </Grid>
            </Grid>

            <Box mt={4} p={3} bgcolor="grey.50" borderRadius={2}>
              <SoftTypography variant="h6" color="dark" fontWeight="bold" mb={2}>
                What is 4CR?
              </SoftTypography>
              <SoftTypography variant="body2" color="text" textAlign="left">
                4CR (For Cricket) is your ultimate destination for cricket enthusiasts. 
                Our platform allows you to create and manage cricket match schedules, 
                organize tournaments, conduct live auctions, and keep everyone informed 
                through timely notifications. Whether you're an individual player, a team, 
                or a cricket club, 4CR provides all the tools you need to manage your 
                cricket activities efficiently.
              </SoftTypography>
            </Box>

            <Box mt={3}>
              <SoftTypography variant="body2" color="text">
                If you believe this is an error, please contact our support team.
              </SoftTypography>
            </Box>
          </CardContent>
        </Card>
      </Container>
    </SoftBox>
  );
}